export const API_BASE_DEV = "http://1.234.5.148:8080";
//export const API_BASE_DEV = "http://localhost:8080"; // CORS 서버 설정 Access-Control-Allow-Origin: *
export const API_BASE_PROD = "https://www.newonefactory.com:8443"; // CORS 서버 설정 Access-Control-Allow-Origin: *
export const API_VERSION_URL = "/new1/api";
export const API_BASE = (process.env.NODE_ENV.includes("dev") ? API_BASE_DEV : API_BASE_PROD) + API_VERSION_URL;
